<template>
  <svg viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_48352_215787)">
      <path d="M27.3008 43.4422H73.7294M50.5151 29.5137L50.5151 71.2994M27.3008 57.3708H73.7294M73.7294 34.1565V66.6565C73.7294 69.2207 71.6507 71.2994 69.0865 71.2994H31.9436C29.3795 71.2994 27.3008 69.2207 27.3008 66.6565V34.1565C27.3008 31.5923 29.3795 29.5137 31.9436 29.5137H69.0865C71.6507 29.5137 73.7294 31.5924 73.7294 34.1565Z" stroke="currentColor" stroke-width="5.57143" />
    </g>
    <defs>
      <clipPath id="clip0_48352_215787">
        <rect x="0.515625" y="0.40625" width="100" height="100" rx="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
